import {useTranslation} from "react-i18next";
import ReactDOM from 'react-dom/client';

import {Link as LinkScroll, animateScroll as scroll, scroller} from "react-scroll";

import React, {useState, useEffect, useRef} from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useLocation,
    useNavigate
} from "react-router-dom";


import successImg from '../../assets/success.png'
import docImg from '../../assets/doc.png'


import {useGlobalFunc, time2date, separatorNumber} from "../../global/constants.js";
import {Pagination} from "@mui/material";
import UserApi from "../../services/UserApi.jsx";
import moment from 'moment'
import {useSelector} from "react-redux";
import SelectImgDialog from "../../compontents/SelectImgDialog.js";
import CountBtn from "../../compontents/CountBtn.js";
import {isValidPhoneNumber} from "../../global/regex";


import policyPDF from '../../assets/policy.pdf';
import CartCounter from "./compontents/CartCounter";
import Tag from "../../compontents/Tag";


const Home = () => {
    const {t, i18n} = useTranslation();
    const navigate = useNavigate()
    const location = useLocation();
    const query = new URLSearchParams(location.search);

    const userInfo = useSelector(state => state.userInfo);


    const [cartData, setCartData] = useState(null)

    const [isUpgrade, setIsUpgrade] = useState(null)

    const [shopRegion, setShopRegion] = useState(null)

    const [invoice, setInvoice] = useState(null)
    const [invoiceName, setInvoiceName] = useState("")
    const [invoiceNumber, setInvoiceNumber] = useState("")

    const [open, setOpen] = useState(false);
    const [selectedValue, setSelectedValue] = useState('');


    const handleClickOpen = (value) => {
        setSelectedValue(value)
        setOpen(true);
    };

    const handleClose = (value, type) => {
        setOpen(false);
        updateData(type, value)
    };

    // 自取匯款的帳號後五碼驗證
    const validateAccountLastFive = (value) => {
        // 檢查是否為5位數字
        const isValid = /^\d{5}$/.test(value);
        setAccountLastFiveError(!isValid);
        return isValid;
    };

// 匯款(郵遞)的帳號後五碼驗證
    const validateTransferAccountLastFive = (value) => {
        // 檢查是否為5位數字
        const isValid = /^\d{5}$/.test(value);
        setTransferAccountLastFiveError(!isValid);
        return isValid;
    };

// 更新自取匯款帳號後五碼的輸入處理
    const handleAccountLastFiveChange = (e) => {
        const value = e.target.value;
        // 只允許輸入數字
        if (/^\d*$/.test(value) && value.length <= 5) {
            setAccountLastFive(value);
            if (value.length === 5) {
                validateAccountLastFive(value);
            } else if (value.length < 5) {
                setAccountLastFiveError(false);
            }
        }
    };

// 更新郵遞匯款帳號後五碼的輸入處理
    const handleTransferAccountLastFiveChange = (e) => {
        const value = e.target.value;
        // 只允許輸入數字
        if (/^\d*$/.test(value) && value.length <= 5) {
            setTransferAccountLastFive(value);
            if (value.length === 5) {
                validateTransferAccountLastFive(value);
            } else if (value.length < 5) {
                setTransferAccountLastFiveError(false);
            }
        }
    };

    // 付款方式切換處理
    const handlePayTypeChange = (type) => {
        setPayType(type);

        if (type === 2) {
            setShipFee(0);
        }

        // 如果不是匯款(郵遞)，重置相關狀態
        if (type !== 1) {
            setTransferAccountLastFive('');
            setTransferAccountLastFiveError(false);
        }

        // 如果不是自取，或切換到自取付現，重置自取匯款狀態
        if (type !== 2) {
            setAccountLastFive('');
            setAccountLastFiveError(false);
            // 如果切換到非自取，確保pickupPaymentType被重置為默認值
            setPickupPaymentType('cash');
        }
    };

// 自取付款方式切換處理
    const handlePickupPaymentTypeChange = (type) => {
        setPickupPaymentType(type);

        // 如果不是匯款，重置帳號後五碼
        if (type !== 'transfer') {
            setAccountLastFive('');
            setAccountLastFiveError(false);
        }
    };

    const [payType, setPayType] = useState(null)
    const [sameOrderInfo, setSameOrderInfo] = useState(false)
    const [pickupPaymentType, setPickupPaymentType] = useState('cash'); // 預設取貨時付現
    const [accountLastFive, setAccountLastFive] = useState(''); // 自取匯款的帳號後五碼
    const [accountLastFiveError, setAccountLastFiveError] = useState(false); // 自取匯款的錯誤狀態
    const [transferAccountLastFive, setTransferAccountLastFive] = useState(''); // 匯款(郵遞)的帳號後五碼
    const [transferAccountLastFiveError, setTransferAccountLastFiveError] = useState(false); // 匯款(郵遞)的錯誤狀態

    const [data, setData] = useState(
        {
            "ordererName": "",
            "ordererPhone": "",
            "email": "",
            "recipientName": "",
            "recipientPhone": "",
            "recipientAddress": "",
        }
    )

    const updateData = (i, value) => {
        setData(prevData => ({...prevData, [i]: value}));
    };

    const handleCart = (id, quantity) => {
        // if (!(quantity > 0 && quantity < 99999999)) {
        //     return
        // }
        const temp = cartData.products.map(item => {
            if (item.id === id) {

                return {
                    ...item, shoppingCart: {
                        ...item.shoppingCart,
                        quantity: quantity
                    }
                };
            }
            return item;
        });
        console.log({...cartData, products: temp})

        setCartData({...cartData, products: temp});
        addCart(id, quantity)
    };


    function nextStep() {
        if (cartData === null) {
            return
        }

        if (step == 0 && cartData.products.length == 0) {
            errorToast('請先新增商品到購物車')
            return
        }
        // if (step == 0) {
        //     errorToast('系統維護中，暫停下單功能。')
        //     return
        // }

        if (step == 0 && shopRegion == null) {
            errorToast('請選擇地區')
            return
        }
        if (step == 0 && payType == null) {
            errorToast('請選擇付款方式')
            return
        }

        // 新增：檢查當付款方式為匯款(郵遞)時，帳號後五碼必須正確
        if (step == 0 && payType === 1) {
            if (transferAccountLastFive.length !== 5 || !/^\d{5}$/.test(transferAccountLastFive)) {
                errorToast('請輸入正確的帳號後五碼（5位數字）')
                setTransferAccountLastFiveError(true)
                return
            }
        }

        // 新增：檢查當付款方式為自取且選擇匯款時，帳號後五碼必須正確
        if (step == 0 && payType === 2 && pickupPaymentType === 'transfer') {
            if (accountLastFive.length !== 5 || !/^\d{5}$/.test(accountLastFive)) {
                errorToast('請輸入正確的帳號後五碼（5位數字）')
                setAccountLastFiveError(true)
                return
            }
        }


        // if (step == 0 && payType === 0 && productPriceData.totalDiscountProductPrice > 100000) {
        //     errorToast('價格總計超過NT$100,000 不能使用信用卡刷卡')
        //     return
        // }
        // if (step == 0 && payType === 1 && data.img5 == null) {
        //     errorToast('請上傳匯款證明圖片')
        //     return
        // }
        if (step == 1) {
            if (!isValidPhoneNumber(data.ordererPhone)) {
                errorToast('請輸入訂購人正確電話格式')
                return
            }
            if (!sameOrderInfo) {
                if (!isValidPhoneNumber(data.recipientPhone)) {
                    errorToast('請輸入收件人正確電話格式')
                    return
                }
            }
            if (invoice == null) {
                errorToast('請選擇發票方式')
                return
            }
            console.log(payType, data.recipientAddress)
            if (invoice == 'company' && invoiceNumber == "") {
                errorToast('請輸入發票公司統編')
                return
            }
            if (invoice == 'company' && invoiceName == "") {
                errorToast('請輸入發票公司抬頭')
                return
            }
            if (payType != 2 && (data.recipientAddress == "" || data.recipientAddress == undefined)) {
                errorToast('請輸入收件地址')
                return
            }

        }

        if (step == 1 && sameOrderInfo) {
            setData({
                ...data, "recipientName": data.ordererName,
                "recipientPhone": data.ordererPhone
            })
        }


        setStep(step + 1)
    }

    const {setLoading, successToast, errorToast, updateMe} = useGlobalFunc()

    const [step, setStep] = useState(0);
    const [shipFee, setShipFee] = useState(0);


    async function getDataList() {
        //  setLoading(true)
        try {
            let res = await UserApi.cartGet({})
            console.log(res.data.data)

            setCartData(res.data.data)
            if (res.data.data.upgradeData.isUpgrade == false) {
                setIsUpgrade(false)
            }

        } catch (errors) {
            navigate('/login')
            errorToast(errors?.response?.data?.message || errors.toString())
        }
        //   setLoading(false)
    }

    async function addCart(id, quantity) {
        //setLoading(true)
        try {
            let res = await UserApi.cartAdd({"id": id, "quantity": quantity})
            console.log(res.data.data)
            getDataList()

        } catch (errors) {
            errorToast(errors?.response?.data?.message || errors.toString())
            // setLoading(false)
        }
    }

    async function removeCart(id) {
        setLoading(true)
        try {
            let res = await UserApi.cartRemove({"id": id})
            console.log(res.data.data)
            //successToast('成功移出購物車')
            getDataList()

        } catch (errors) {
            errorToast(errors?.response?.data?.message || errors.toString())
        } finally {
            setLoading(false)
        }
    }

    async function orderPay() {

        let tempProducts = []
        console.log(cartData)
        cartData.products.forEach(i => {
            tempProducts.push({productId: i.id})

        });
        console.log(tempProducts)

        // if (userInfo.shoppingPoints > 0) {
        //     if (userInfo.shoppingPoints != cartData.productPriceData.totalProductPrice) {
        //         errorToast('請選擇正確的購物金商品。')
        //         return
        //     }
        // }

        if (cartData.upgradeData.isUpgrade && isUpgrade == null) {
            errorToast('請選擇是否同意本「經銷商合約」於今日進階。')
            return
        }

        let payMethod = ""
        let shipFeeVal = 0
        let creditFee = 0
        if (payType == 0) {
            payMethod = "creditCard"
            shipFeeVal = Number(shipFee)
            creditFee = Math.round((cartData.productPriceData.totalPrice + shipFeeVal) * 0.03);
        } else if (payType == 1) {
            payMethod = "bankTransfer"
            shipFeeVal = Number(shipFee)
        } else if (payType == 2) {
            payMethod = "offline"
            shipFeeVal = 0
        }

        setLoading(true)
        let json = {
            "payMethod": payMethod,
            "shipMethod": payType == 2 ? "self-pickup" : "delivery",
            "isUpgrade": isUpgrade,
            "invoice": {
                "type": invoice,
            },
            "useShoppingPoints": userInfo.shoppingPoints > 0,
            "shippingRegion": shopRegion,
            "shipFee": shipFeeVal,
            "creditFee": creditFee,
            "contact": {
                "ordererName": data.ordererName,
                "ordererPhone": data.ordererPhone,
                "email": data.email,
                "recipientName": data.recipientName,
                "recipientPhone": data.recipientPhone,

            },
            "products": tempProducts,
            "accountLastFive": payType === 1 ? transferAccountLastFive :
                (payType === 2 && pickupPaymentType === 'transfer' ? accountLastFive : "")
        }
        if (invoice == 'company') {
            json.invoice.name = invoiceName
            json.invoice.number = invoiceNumber
        }
        if (payType != 2) {
            json.contact.recipientAddress = data.recipientAddress
        }

        try {
            let res = await UserApi.orderPay(json)

            //console.log(res.data)

            //let orderCoinToken = await axios.post(api_url, json, { headers: headers })

            //let docData = await axios.post(api_pay_url, { payload: orderCoinToken.data }, { headers: headers })
            //console.log(docData)
            if (payType > 0) {
                setStep(step + 1)
                updateMe()

            } else {
                document.open();
                document.write(res.data)
            }
            //successToast(t('removeCart Success'))
            //getDataList()
            //nextStep()
        } catch (errors) {
            errorToast(errors?.response?.data?.message || errors.toString())
            setLoading(false)
        }
        setLoading(false)

    }

    useEffect(() => {
        getDataList()
    }, []);

    useEffect(() => {
        window.scroll(0, 0)
    }, [step]);

    const isFisrt = useRef(true)
    useEffect(() => {
        console.log(userInfo)
        if (userInfo && isFisrt.current) {
            isFisrt.current = false
            setData({
                "ordererName": userInfo.name,
                "ordererPhone": userInfo.phone,
                "email": userInfo.email,
            })

        }
    }, [userInfo]);


    return <div className="session1 relative pt-[40px] pb-20 bg-white">

        <div className="flex justify-center items-center">
            {
                ["付款方式", "填寫資料", "確認訂單", "確認訂單"].map((i, index) => <div className="flex items-center">
                    <div>

                        <div
                            className={`${step >= index ? 'bg-black96' : ''} p-0.5 w-10 h-10 rounded-full mx-auto mb-1`}>
                            <div
                                className={`${step >= index ? 'bg-black96' : 'bg-black5'} flex  border-solid border-white border-2 w-full h-full rounded-full`}>
                                <div className="m-auto text-white font-bold">{index + 1}</div>
                            </div>
                        </div>
                        <p className={`${step >= index ? 'text-black96' : 'text-black6'}  text-xs text-center whitespace-nowrap`}>{i}</p>
                    </div>

                    {
                        index < 3 ?
                            <div className={`${step > index ? 'bg-black96' : 'bg-black5'}  w-8 h-0.5 mb-4`}>
                            </div> : ""
                    }

                </div>)

            }

        </div>

        {
            step == 0 && cartData && <div>
                <div className="mt-10 mb-10">
                    <p className="text-xl text-black9 font-bold mb-4">購物清單</p>
                    <div className="   whitespace-nowrap w-full  overflow-x-auto pb-10">
                        <table className="w-full text-sm mb-4 ">
                            <thead className="">

                            <tr className=" text-xs text-black96 bg-black02 font-semibold ">
                                <th className="">產品</th>
                                <th></th>
                                <th className="">價格</th>
                                <th className="">小計</th>
                                <th className=""></th>

                            </tr>
                            </thead>


                            <tbody>

                            {
                                cartData.products.map(i => <tr className=" text-black9 font-semibold ">
                                        <td className="min-w-[120px] w-[120px]">
                                            <img className="w-full aspect-[1/1] object-cover rounded-lg"
                                                 src={i.images.length > 0 && i.images[0].image}/>
                                        </td>
                                        <td className="min-w-[150px] ">
                                            {i.name}
                                            <div className="flex flex-wrap gap-2 items-center mt-1">
                                                {
                                                    !i.isDiscount &&
                                                    <Tag className="" title="不打折"/>
                                                }
                                                {
                                                    i.isShoppingPointPackage &&
                                                    <Tag className="" title="購物金商品"/>
                                                }
                                            </div>
                                            <div className="w-[150px] mt-2">
                                                {/* <CountBtn count={i.quantity} setCount={handleCart(i.id, i.quantity)} /> */}
                                                <div
                                                    className=" items-stretch relative flex  text-black border border-solid border-black4 overflow-hidden rounded-md">
                                                    <button className="w-[40px] flex-none aspect-[1/1] bg-[#F0F0F0]"
                                                            onClick={() => handleCart(i.id, i.shoppingCart.quantity - 1)}>-
                                                    </button>
                                                    <input
                                                        type="tel"
                                                        className="text-center w-full border-0 p-0 !text-[#534841] !rounded-none"
                                                        value={Number(i.shoppingCart.quantity)}
                                                        onChange={(e) => handleCart(i.id, (Number(e.target.value)))}
                                                    />
                                                    <button className="w-[40px] flex-none min-h-full  bg-[#F0F0F0]"
                                                            onClick={() => handleCart(i.id, i.shoppingCart.quantity + 1)}>+
                                                    </button>
                                                </div>
                                            </div>

                                        </td>
                                        <td className="">NT$ {separatorNumber(i.price)}</td>
                                        <td>NT$ {separatorNumber(i.price * i.shoppingCart.quantity)}</td>
                                        <td className="">
                                            <button onClick={() => removeCart(i.id)}
                                                    className=" rounded-full font-semibold text-xl text-gray1">X
                                            </button>
                                        </td>


                                    </tr>
                                )
                            }


                            </tbody>

                        </table>
                    </div>
                    <div className="w-full h-0.5 bg-black06"></div>

                    <div className="flex justify-between mt-8">
                        <Link to="/">
                            <button className="text-black6 flex items-center gap-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32"
                                     fill="none">
                                    <path
                                        d="M21.957 3.70593C22.2526 4.04322 22.4004 4.44256 22.4004 4.90397C22.4004 5.36448 22.2526 5.76337 21.957 6.10066L13.2955 15.9831L21.9865 25.8993C22.2624 26.2141 22.4004 26.6076 22.4004 27.0798C22.4004 27.552 22.2526 27.9568 21.957 28.2941C21.6614 28.6314 21.3114 28.8 20.907 28.8C20.5033 28.8 20.1537 28.6314 19.8581 28.2941L9.92556 16.9275C9.80732 16.7926 9.72337 16.6465 9.6737 16.4891C9.62483 16.3317 9.60039 16.163 9.60039 15.9831C9.60039 15.8033 9.62483 15.6346 9.6737 15.4772C9.72337 15.3198 9.80732 15.1737 9.92556 15.0387L19.8877 3.6722C20.1636 3.3574 20.5034 3.2 20.907 3.2C21.3114 3.2 21.6614 3.36864 21.957 3.70593Z"
                                        fill="currentColor" stroke="currentColor"/>
                                </svg>
                                繼續購物
                            </button>
                        </Link>
                        <div className="text-right">

                            <CartCounter userInfo={userInfo} data={cartData.productPriceData} payType={payType} shipFee={shipFee}/>

                        </div>
                    </div>
                </div>


                <div className="mb-10">
                    <p className="text-xl text-black9 font-bold mb-4">請選擇地區</p>
                    <div className="w-full h-0.5 bg-black06"></div>
                    <div className="flex gap-8 p-4">
                        {
                            ['Taipei'].map(i => <div key={i} className="flex gap-1 items-center cursor-pointer"
                                                     onClick={() => setShopRegion(i)}>
                                    <input type="radio" checked={shopRegion == i}/>
                                    <p className="text-black9">{t(i)}</p>
                                </div>
                            )}
                        {
                            ['Taichung', 'Kaohsiung'].map(i => <div key={i}
                                                                    className="flex gap-1 items-center pointer-events-none">
                                    <input disabled type="radio" checked={shopRegion == i}/>
                                    <p className="text-black6">{t(i)}</p>
                                </div>
                            )}

                    </div>

                </div>

                <div className="mb-10">
                    <p className="text-xl text-black9 font-bold mb-4">請選擇付款方式</p>
                    <div className="w-full h-0.5 bg-black06"></div>
                    <div className="flex gap-4 sm:gap-6 flex-col sm:flex-row py-8 items-start">
                        <button onClick={() => handlePayTypeChange(0)}
                                className={`${payType === 0 ? "bg-red1 text-white border-transparent" : " border-black8 text-black8"} border border-solid rounded-full w-60 py-2 text-sm  font-bold flex-none`}>信用卡刷卡(郵遞)
                            (一次付清)
                        </button>
                        <div className="text-black8 text-sm">
                            <p>在您輸入卡號與授權碼後，
                                會連結至輸入「3D驗證」密碼的頁面，如您尚未取得密碼，請您至發卡行網站取得密碼，唯發卡行與您知道此密碼，本平台亦不會記錄。</p>
                            <p className="text-red-500 text-sm font-medium">將酌收3%手續費</p>
                        </div>
                    </div>

                    <div className="w-full h-0.5 bg-black06"></div>
                    <div className="flex gap-4 sm:gap-6 flex-col sm:flex-row py-8 items-start">
                        <button onClick={() => handlePayTypeChange(1)}
                                className={`${payType === 1 ? "bg-red1 text-white border-transparent" : " border-black8 text-black8"} border border-solid rounded-full w-60 py-2 text-sm  font-bold flex-none`}>匯款(郵遞)
                        </button>
                        <div className="text-black8 text-sm w-full">
                            <p className="font-bold">匯款帳號</p>
                            <p>第一銀行</p>
                            <p>銀行代號 007</p>
                            <p>戶名 前端星技股份有限公司</p>
                            <p className="mb-2">帳號 13310030771</p>
                            <div className="mt-4">
                                <p className="font-bold mb-2">請輸入帳號後五碼</p>
                                <input
                                    type="text"
                                    className="border border-solid border-black4 rounded-md px-3 py-2 w-full max-w-xs"
                                    placeholder="請輸入帳號後五碼"
                                    value={transferAccountLastFive}
                                    onChange={handleTransferAccountLastFiveChange}
                                    required
                                    maxLength={5}
                                    pattern="[0-9]{5}"
                                    onBlur={() => {
                                        if (transferAccountLastFive) {
                                            validateTransferAccountLastFive(transferAccountLastFive);
                                        }
                                    }}
                                />
                                {transferAccountLastFiveError && (
                                    <p className="text-red-500 text-xs mt-1">請輸入正確的帳號後五碼</p>
                                )}
                            </div>
                            {
                                false &&
                                <div className="relative w-full">

                                    <p className="font-bold">匯款證明圖片</p>
                                    <div onClick={() => handleClickOpen('img5')}
                                         className="relative cursor-pointer w-full sm:w-60 aspect-[1/1]  border border-main2 border-solid flex justify-center items-center text-black8 text-xl font-bold text-center">
                                        <div>
                                            <img className="w-10 h-10 object-contain mb-4 mx-auto" src={docImg}/>
                                            <img className=" w-full h-full absolute left-0 top-0 object-contain"
                                                 src={data.img5}/>
                                        </div>
                                    </div>
                                </div>
                            }

                        </div>
                    </div>

                    <div className=" w-full h-0.5 bg-black06"></div>
                    <div className=" flex gap-4 sm:gap-6 flex-col sm:flex-row py-8 items-start">
                        <button onClick={() => handlePayTypeChange(2)}
                                className={`${payType === 2 ? "bg-red1 text-white border-transparent" : " border-black8 text-black8"} border border-solid rounded-full w-60 py-2 text-sm  font-bold flex-none`}>自取結帳
                        </button>
                        <div className="text-black8 text-sm">
                            <div className="flex flex-col gap-4">
                                <div className="flex items-center gap-2">
                                    <input
                                        type="radio"
                                        id="pickup-cash"
                                        name="pickup-payment"
                                        checked={pickupPaymentType === 'cash'}
                                        onChange={() => handlePickupPaymentTypeChange('cash')}
                                    />
                                    <label htmlFor="pickup-cash" className="cursor-pointer">取貨時付現</label>
                                </div>

                                <div className="flex flex-col gap-2">
                                    <div className="flex items-center gap-2">
                                        <input
                                            type="radio"
                                            id="pickup-transfer"
                                            name="pickup-payment"
                                            checked={pickupPaymentType === 'transfer'}
                                            onChange={() => handlePickupPaymentTypeChange('transfer')}
                                        />
                                        <label htmlFor="pickup-transfer" className="cursor-pointer">匯款</label>
                                    </div>

                                    {pickupPaymentType === 'transfer' && (
                                        <div className="ml-6 mt-2">
                                            <p className="font-bold mb-2">請輸入帳號後五碼</p>
                                            <input
                                                type="text"
                                                className="border border-solid border-black4 rounded-md px-3 py-2 w-full max-w-xs"
                                                placeholder="請輸入帳號後五碼"
                                                value={accountLastFive}
                                                onChange={handleAccountLastFiveChange}
                                                required
                                                maxLength={5}
                                                pattern="[0-9]{5}"
                                                onBlur={() => {
                                                    if (accountLastFive) {
                                                        validateAccountLastFive(accountLastFive);
                                                    }
                                                }}
                                            />
                                            {accountLastFiveError && (
                                                <p className="text-red-500 text-xs mt-1">請輸入正確的帳號後五碼</p>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="hidden w-full h-0.5 bg-black06"></div>
                    <div className="hidden flex gap-4 sm:gap-6 flex-col sm:flex-row py-8 items-start">
                        <button
                            className=" border border-solid border-black8 rounded-full w-60 py-2 text-sm text-black8 font-bold flex-none">信用卡刷卡
                            (分期付款)
                        </button>
                        <div className="text-black8 text-sm">
                            僅限玉山銀行(3期)<br/><br/>
                            在您輸入卡號與授權碼後， 會連結至輸入「3D驗證」密碼的頁面，如您尚未取得密碼，請您至發卡行網站取得密碼，唯發卡行與您知道此密碼，本平台亦不會記錄。
                        </div>
                    </div>
                    <div className="hidden w-full h-0.5 bg-black06"></div>

                    <div className="hidden flex gap-4 sm:gap-6 flex-col sm:flex-row py-8 items-start">
                        <button
                            className=" border border-solid border-black8 rounded-full w-60 py-2 text-sm text-black8 font-bold flex-none">ATM
                            匯款 / 臨櫃轉帳
                        </button>
                        <div className="text-black8 text-sm">
                            選擇ATM匯款／臨櫃轉帳。
                        </div>
                    </div>
                    <div className="w-full h-0.5 bg-black06"></div>
                </div>

                {
                    (payType === 0 || payType === 1) &&
                    <div className="mb-10 mt-8">
                        <p className="text-xl text-black9 font-bold mb-4">請輸入運費</p>
                        <div className="w-full h-0.5 bg-black06"></div>
                        <div className="py-6 flex items-center gap-4">
                            <input
                                type="number"
                                min="0"
                                className="border border-solid border-black4 rounded-md px-3 py-2 w-full max-w-xs text-black9 font-bold"
                                placeholder="請輸入運費金額"
                                value={shipFee}
                                onChange={(e) => {
                                    const val = e.target.value;
                                    if (val === '') {
                                        setShipFee('');
                                    } else {
                                        const parsed = parseInt(val, 10);
                                        if (!isNaN(parsed) && parsed >= 0) {
                                            setShipFee(parsed);
                                        }
                                    }
                                }}
                                onBlur={() => {
                                    if (shipFee === '' || isNaN(parseInt(shipFee, 10))) {
                                        setShipFee(0);
                                    }
                                }}
                            />
                            <span className="text-black8 font-medium">元</span>
                        </div>
                    </div>
                }

                <div className="flex justify-end mt-8">
                    <button onClick={() => nextStep()} className="btn1 !min-w-[140px] ">前往結帳</button>
                </div>

            </div>

        }
        {
            step == 1 && <div className="py-12">
                <div className="mb-4 mt-8 flex items-center gap-4 flex-wrap">
                    <p className="text-xl text-black9 font-bold ">訂購人資訊</p>

                </div>

                <div className="px-6 py-12 bg-white border-solid border-4 border-black06 rounded-[20px] relative  w-full ">
                    <div className="flex text-black9 break-all w-full sm:max-w-[500px] justify-center mx-auto ">
                        <div className="w-full">
                            <div className="mb-6 w-full sm:flex  items-center gap-2">
                                <p className="flex-none min-w-[120px]">訂購人姓名<span className="text-red1">*</span></p>
                                <input className="w-full" onChange={(e) => updateData('ordererName', e.target.value)}
                                       value={data.ordererName}/>
                            </div>
                            <div className="mb-6 w-full sm:flex  items-center gap-2">
                                <p className="flex-none min-w-[120px]">聯絡電話<span className="text-red1">*</span></p>
                                <div className="flex items-center gap-2 w-full">
                                    <div className="flex-none">+886</div>
                                    <input className="w-full" maxLength="10" type="text"
                                           onChange={(e) => updateData('ordererPhone', e.target.value)}
                                           value={data.ordererPhone}/>
                                </div>
                            </div>
                            <div className=" w-full sm:flex  items-center gap-2">
                                <p className="flex-none min-w-[120px]">電子郵件<span className="text-red1">*</span></p>
                                <input className="w-full" onChange={(e) => updateData('email', e.target.value)}
                                       value={data.email}/>
                            </div>

                        </div>
                    </div>

                </div>

                <div className="mb-4 mt-8 flex items-center gap-4 flex-wrap">
                    <p className="text-xl text-black9 font-bold ">收件人資訊</p>
                    <button onClick={() => setSameOrderInfo(!sameOrderInfo)}
                            className={`${sameOrderInfo ? "bg-black9 text-white" : "border-solid  border-black5 text-black5"} px-8 py-[10px] text-sm border rounded-full`}>同訂購人資訊
                    </button>
                </div>
                <div className="px-6 py-12 bg-white border-solid border-4 border-black06 rounded-[20px] relative  w-full ">
                    <div className="flex text-black9 break-all w-full sm:max-w-[500px] justify-center mx-auto ">
                        <div className="w-full">
                            <div className="mb-6 w-full sm:flex  items-center gap-2">
                                <p className="flex-none min-w-[120px]">收件人姓名<span className="text-red1">*</span></p>
                                {
                                    !sameOrderInfo ?
                                        <input className="w-full"
                                               onChange={(e) => updateData('recipientName', e.target.value)}
                                               value={data.recipientName}/>
                                        :
                                        <div className="py-2">
                                            {data.ordererName}
                                        </div>
                                }
                            </div>
                            <div className="mb-6 w-full sm:flex  items-center gap-2">
                                <p className="flex-none min-w-[120px]">聯絡電話<span className="text-red1">*</span></p>
                                {
                                    !sameOrderInfo ?
                                        <div className="flex items-center gap-2 w-full">
                                            <div className="flex-none">+886</div>
                                            <input className="w-full" maxLength="10" type="text"
                                                   onChange={(e) => updateData('recipientPhone', e.target.value)}
                                                   value={data.recipientPhone}/>
                                        </div>
                                        :
                                        <div className="py-2">
                                            <span className="flex-none">+886</span> {data.ordererPhone}
                                        </div>
                                }

                            </div>
                            {
                                payType != 2 &&
                                <div className=" w-full sm:flex  items-center gap-2">
                                    <p className="flex-none min-w-[120px]">收件地址<span className="text-red1">*</span></p>
                                    <input className="w-full"
                                           onChange={(e) => updateData('recipientAddress', e.target.value)}
                                           value={data.recipientAddress}/>
                                </div>
                            }
                        </div>
                    </div>
                </div>

                <div className="mb-4 mt-8 flex items-center gap-4 flex-wrap">
                    <p className="text-xl text-black9 font-bold ">發票</p>
                </div>

                <div className="px-6 py-12 bg-white border-solid border-4 border-black06 rounded-[20px] relative  w-full ">
                    <div className="flex text-black9 break-all w-full sm:max-w-[500px] justify-center mx-auto ">
                        <div className="w-full">
                            <div className=" w-full sm:flex  items-center gap-2">
                                <p className="flex-none min-w-[120px]">方式<span className="text-red1">*</span></p>
                                <div className="flex gap-8 ">
                                    {
                                        ['donate', 'personal', 'company'].map(i => <div key={i}
                                                                                        className="flex gap-1 items-center cursor-pointer"
                                                                                        onClick={() => setInvoice(i)}>
                                                <input type="radio" checked={invoice == i}/>
                                                <p className="text-black9">{t(i)}</p>
                                            </div>
                                        )}

                                </div>
                            </div>
                            {
                                invoice == 'company' &&
                                <div className=" w-full mt-4">
                                    <p className="flex-none min-w-[120px]">公司抬頭<span className="text-red1">*</span></p>
                                    <input className="w-full mb-2" onChange={(e) => setInvoiceName(e.target.value)}
                                           value={invoiceName}/>
                                    <p className="flex-none min-w-[120px]">公司統編<span className="text-red1">*</span></p>
                                    <input className="w-full" onChange={(e) => setInvoiceNumber(e.target.value)}
                                           value={invoiceNumber}/>
                                </div>
                            }

                        </div>
                    </div>

                </div>

                <div className="flex justify-between mt-8">
                    <button onClick={() => setStep(step - 1)} className="flex items-center text-black6 font-bold gap-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32" fill="none">
                            <path
                                d="M21.957 3.70593C22.2526 4.04322 22.4004 4.44256 22.4004 4.90397C22.4004 5.36448 22.2526 5.76337 21.957 6.10066L13.2955 15.9831L21.9865 25.8993C22.2624 26.2141 22.4004 26.6076 22.4004 27.0798C22.4004 27.552 22.2526 27.9568 21.957 28.2941C21.6614 28.6314 21.3114 28.8 20.907 28.8C20.5033 28.8 20.1537 28.6314 19.8581 28.2941L9.92556 16.9275C9.80732 16.7926 9.72337 16.6465 9.6737 16.4891C9.62483 16.3317 9.60039 16.163 9.60039 15.9831C9.60039 15.8033 9.62483 15.6346 9.6737 15.4772C9.72337 15.3198 9.80732 15.1737 9.92556 15.0387L19.8877 3.6722C20.1636 3.3574 20.5034 3.2 20.907 3.2C21.3114 3.2 21.6614 3.36864 21.957 3.70593Z"
                                fill="currentColor" stroke="currentColor"/>
                        </svg>
                        回購物車
                    </button>
                    <button onClick={() => nextStep()} className="btn1 !min-w-[140px] ">確認資訊</button>
                </div>
            </div>
        }

        {
            step == 2 && cartData && <div className="py-12">
                <p className="text-xl text-black9 font-bold mb-4">訂購人資訊</p>

                <div className="mt-10 mb-10">
                    <p className="text-xl text-black9 font-bold mb-4">購物清單</p>

                    <div className="   whitespace-nowrap w-full  overflow-x-auto pb-10">
                        <table className="w-full text-sm mb-4">
                            <thead className="">

                            <tr className="  text-main6 font-semibold ">
                                <th className="">產品</th>
                                <th className=""></th>
                                <th className="">價格</th>
                                <th className="">數量</th>
                                <th className="">小計</th>


                            </tr>
                            </thead>


                            <tbody>
                            {
                                cartData.products.map(i => <tr className=" text-black9 font-semibold ">

                                        <td className="min-w-[120px] w-[120px]">
                                            <img className="w-full aspect-[1/1] object-cover rounded-lg"
                                                 src={i.images.length > 0 && i.images[0].image}/>
                                        </td>
                                        <td className="">{(i.name)}
                                            <div className="flex flex-wrap gap-2 items-center mt-1">
                                                {
                                                    !i.isDiscount &&
                                                    <Tag className="" title="不打折"/>
                                                }
                                                {
                                                    i.isShoppingPointPackage &&
                                                    <Tag className="" title="購物金商品"/>
                                                }
                                            </div>
                                        </td>
                                        <td className="">NT$ {separatorNumber(i.price)}</td>
                                        <td className="">{separatorNumber(i.shoppingCart.quantity)}</td>
                                        <td>NT$ {separatorNumber(i.price * i.shoppingCart.quantity)}</td>

                                    </tr>
                                )
                            }
                            </tbody>

                        </table>
                    </div>
                    <div className="w-full h-0.5 bg-black06"></div>

                    <div className="flex justify-end mt-8">

                        <div className="text-right">
                            <CartCounter userInfo={userInfo} data={cartData.productPriceData} payType={payType} shipFee={shipFee}/>

                        </div>
                    </div>
                </div>

                {
                    false &&
                    <div className="mb-10">
                        <p className="text-xl text-black9 font-bold mb-4">收件資訊確認</p>
                        <div className="w-full h-0.5 bg-black06"></div>

                        <p className="font-bold text-black7 mb-1 mt-4">匯款證明圖片</p>
                        <div
                            className="relative  w-full sm:w-60 aspect-[1/1]  border border-main2 border-solid flex justify-center items-center text-black8 text-xl font-bold text-center">
                            <div>
                                <img className=" w-full h-full absolute left-0 top-0 object-contain" src={data.img5}/>
                            </div>
                        </div>
                    </div>
                }

                <div className="mb-10">
                    <p className="text-xl text-black9 font-bold mb-4">訂購資訊確認</p>
                    <div className="w-full h-0.5 bg-black06"></div>
                    <div className="flex text-black9 break-all w-full sm:max-w-[500px] justify-center mx-auto py-14">
                        <div className="w-full">
                            <div className="mb-6 w-full flex  items-center gap-2">
                                <p className="flex-none min-w-[100px] text-black6 font-bold">收件人姓名</p>
                                <p className="w-full">{data.recipientName}</p>
                            </div>
                            <div className="mb-6 w-full flex  items-center gap-2">
                                <p className="flex-none min-w-[100px] text-black6 font-bold">聯絡電話</p>
                                <p className="w-full"><span className="flex-none">+886</span> {data.recipientPhone}</p>
                            </div>
                            {
                                payType != 2 &&
                                <div className=" w-full flex  items-center gap-2">
                                    <p className="flex-none min-w-[100px] text-black6 font-bold">收件地址</p>
                                    <p className="w-full">{data.recipientAddress}</p>
                                </div>
                            }
                        </div>
                    </div>
                    <div className="w-full h-0.5 bg-black06"></div>
                </div>

                <div className="mb-10">
                    <p className="text-xl text-black9 font-bold mb-4">發票</p>
                    <div className="w-full h-0.5 bg-black06"></div>
                    <div className="flex text-black9 break-all w-full sm:max-w-[500px] justify-center mx-auto py-14">
                        <div className="w-full">
                            <div className=" w-full flex  items-center gap-2">
                                <p className="flex-none min-w-[100px] text-black6 font-bold">方式</p>
                                <p className="w-full">{t(invoice)}</p>
                            </div>
                            {
                                invoice == 'company' && <div>
                                    <div className=" w-full flex  items-center gap-2 mt-6">
                                        <p className="flex-none min-w-[100px] text-black6 font-bold">公司抬頭</p>
                                        <p className="w-full ">{invoiceName}</p>

                                    </div>
                                    <div className=" w-full flex  items-center gap-2 mt-6">

                                        <p className="flex-none min-w-[100px] text-black6 font-bold">公司統編</p>
                                        <p className="w-full">{invoiceNumber}</p>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                    <div className="w-full h-0.5 bg-black06"></div>
                </div>


                {
                    cartData.upgradeData && cartData.upgradeData.isUpgrade &&
                    <div className="mb-10 ">
                        <p className="text-black9 text-sm font-bold"><span
                            className="text-red1">*</span>您的消費金額已經達到進階成為『{t(`userIdentityType.${cartData.upgradeData.upgradeTo}`)}』的條件，請問您是否同意本<a
                            className="text-red1 hover:underline" href={policyPDF}
                            target="_blank">「經銷商合約」</a>於今日進階為『{t(`userIdentityType.${cartData.upgradeData.upgradeTo}`)}』？
                        </p>
                        <div className="flex gap-4">
                            <div className="flex gap-1 items-center cursor-pointer" onClick={() => setIsUpgrade(true)}>
                                <input type="radio" checked={isUpgrade === true}/>
                                <p className="text-black9">是</p>
                            </div>
                            <div className="flex gap-1 items-center cursor-pointer" onClick={() => setIsUpgrade(false)}>
                                <input type="radio" checked={isUpgrade === false}/>
                                <p className="text-black9">否</p>
                            </div>
                        </div>
                        <div className="w-full h-0.5 bg-black06 mt-10"></div>

                    </div>
                }
                <div className="flex justify-between mt-8">
                    <button onClick={() => setStep(step - 1)} className="flex items-center text-black6 font-bold gap-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32" fill="none">
                            <path
                                d="M21.957 3.70593C22.2526 4.04322 22.4004 4.44256 22.4004 4.90397C22.4004 5.36448 22.2526 5.76337 21.957 6.10066L13.2955 15.9831L21.9865 25.8993C22.2624 26.2141 22.4004 26.6076 22.4004 27.0798C22.4004 27.552 22.2526 27.9568 21.957 28.2941C21.6614 28.6314 21.3114 28.8 20.907 28.8C20.5033 28.8 20.1537 28.6314 19.8581 28.2941L9.92556 16.9275C9.80732 16.7926 9.72337 16.6465 9.6737 16.4891C9.62483 16.3317 9.60039 16.163 9.60039 15.9831C9.60039 15.8033 9.62483 15.6346 9.6737 15.4772C9.72337 15.3198 9.80732 15.1737 9.92556 15.0387L19.8877 3.6722C20.1636 3.3574 20.5034 3.2 20.907 3.2C21.3114 3.2 21.6614 3.36864 21.957 3.70593Z"
                                fill="currentColor" stroke="currentColor"/>
                        </svg>
                        修改訂購資訊
                    </button>
                    <button onClick={() => orderPay()} className="btn1 !min-w-[140px] ">確認結帳</button>
                </div>


            </div>

        }

        {
            step == 3 && <div className="py-12">
                <div className="w-full h-0.5 bg-black06"></div>
                <div className="py-12 w-full">

                    <img className="w-16 object-contain mb-6 mx-auto" src={successImg}/>
                    <p className="mb-6  text-center text-black9 text-xl font-bold">訂單已送出，感謝您的訂購！</p>
                    <p className="text-black7 text-sm text-center mb-8">
                        您可以在「會員中心」中查看處理進度。<br/>
                        如有任何疑問也歡迎隨時與我們聯繫<br/>
                        客服專線： 將由專人為您服務
                    </p>
                    <div className="flex justify-center">
                        <button onClick={() => navigate('/')} className=" btn2 !min-w-[120px]">前往首頁</button>
                    </div>
                </div>
                <div className="w-full h-0.5 bg-black06"></div>
            </div>
        }

        <SelectImgDialog
            type={selectedValue}
            open={open}
            onClose={handleClose}
        />

    </div>

}

export default Home